import { Box, ITheme, SvgIcon, Typography, useTheme } from '@mui/material';
import React from 'react';

export interface IPortfolioFilterButtonProps {
    isActive?: boolean;
    title: string;
    count?: number;
    icon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {title?: string | undefined;}>;
    onClick: () => void;
}

const PortfolioFilterButton: React.FC<IPortfolioFilterButtonProps> = ({ isActive, title, count, icon, onClick }) => {
    const theme = useTheme() as ITheme;

    return <Box display={"flex"} sx={{ cursor: isActive ? "default" : "pointer"}} gap={"16px"} bgcolor={isActive ? theme.palette.leo.primary.blue[200] : theme.palette.common.white} padding={"10px"} borderRadius={"4px"} alignItems={"center"} onClick={onClick}>
        <Box display={"flex"} gap={"6px"} alignItems={"center"}>
            <SvgIcon component={icon} style={{ color: isActive ? theme.palette.common.white : undefined}} inheritViewBox sx={{ width: "17px", height: "17px"}} />
            <Typography color={isActive ? theme.palette.common.white : theme.palette.common.black} fontSize={"14px"} lineHeight={"17.07px"} fontWeight={"500"}>{title}</Typography>
        </Box>
        <Typography fontSize={"14px"} lineHeight={"17.07px"} fontWeight={"500"} color={isActive ? theme.palette.common.white : undefined}>{count !== undefined ? count : "..."}</Typography>
    </Box>
}

export default PortfolioFilterButton;